// extracted by mini-css-extract-plugin
export default {"listContainer":"TargetsList-module__listContainer--up17j"};